export default "__VITE_ASSET__DWh1jw0___"